<template>
  <div class="view-layout" :class="bgColor">
    <Progress progress="87" v-if="progressShow"></Progress>
    <div class="page-header" :class="{'none-page':!progressShow, 'en-header': currentLang === 'en'}">
      {{ $t("open_account.risk_disclosure.page_title") }}
    </div>
    <div class="audio-wrapper">
      <div class="audio-container">
        <div class="info-box">
          <div class="head-img">
            <img :src="userInfoData.headImg" class="img" />
          </div>
          <div class="text-box">
            <p class="name">{{ $t('open_account.risk_disclosure.p1') }}：{{userInfoData.name}}</p>
            <p class="code">{{ $t('open_account.risk_disclosure.p2') }}：{{userInfoData.serialNo}}</p>
          </div>
          <div class="btn-wrapper">
            <div class="btn" @click="togglePlay">
              <div class="play-icon" v-if="!playing"></div>
              <div class="pause-icon" v-else></div>
            </div>
            <div v-show="showGesture" class="gesture-icon">👆</div>
          </div>
          <audio 
            ref="audioPlayer" 
            @ended="onAudioEnded" 
            @loadedmetadata="onAudioLoaded"
            @timeupdate="onTimeUpdate">
            <source :src="audioSources[currentLanguage]" type="audio/mp3">
          </audio>
        </div>
        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: progressPercent + '%' }">
            <img v-show="playing || (currentTime > 0 && !audioCompleted)" class="progress-dot" src="@/assets/images/open-account/dot.png" alt="">
          </div>
        </div>
        <div class="audio-controls">
          <div  class="control-item" @click="toggleLanguageSelect">
            <span class="control-label">{{ languageText }}</span>
            <img class="icon" :src="arrowIcon" alt="">
          </div>
          <div class="control-item" @click="toggleSpeedSelect">
            <span class="control-label">{{ playbackRate.toFixed(1) }} {{ $t('open_account.risk_disclosure.p3') }}</span>
            <img class="icon" :src="arrowIcon" alt="">
          </div>
          <span class="duration-text">{{ $t('open_account.risk_disclosure.p7') }} {{ audioDurationText }}</span>
        </div>
      </div>
      
      <!-- 语言选择 -->
      <ActionSheet 
        :value="showType === 1" 
        :actions="languageOptions"
        @input="val => !val && (showType = 0)"
        @select="selectLanguage" />
      
      <!-- 倍速选择 -->
      <ActionSheet 
        :value="showType === 2" 
        :actions="speedOptions"
        @input="val => !val && (showType = 0)"
        @select="selectSpeed" />
    </div>
    <div class="page-content">
      <div class="detail-wrap" id="detail-wrap-6" v-if="0">
        <p
          v-for="(item, index) in $t('open_account.risk_content.p1')"
          :key="item + '' + index"
        >
          {{ item }}
        </p>
        <p
          v-for="(item, index) in $t('open_account.risk_content.p2')"
          :key="item + '' + index"
        >
          {{ item }}
        </p>
      </div>
      <div class="detail-wrap" v-html="formattedContent" @click="handleLinkClick"></div>
    </div>
    <nav-buttons @on-next="handleNext" navigationType="back" :disabled="!audioCompleted"></nav-buttons>
  </div>
</template>

<script>
import { Toast, ActionSheet } from "vant";
import navButtons from "../components/navButtons.vue";
import Progress from "../components/Progress.vue";
import { openAgreementPdf } from '../utils/resolveAgreementPdf'
import _ from "lodash";
export default {
  components: {
    navButtons,
    Progress,
    ActionSheet
  },
  data() {
    return {
      process_id: "",
      account_status:"",
      isRead:false,
      hbStaus:1,
      openServerData: '',
      userInfoData: {},
      serverIdData: '',
      playing: false,
      showGesture: true,
      currentLanguage: 'cn',
      playbackRate: 1.0,
      audioDuration: 0,
      currentTime: 0,
      audioCompleted: false,
      showType: 0, // 0-隐藏 1-语言 2-倍速
    };
  },
  mounted() {
    this.init();
  },
  computed:{
    formattedContent() {
      const content = this.$t('fxfl.' + this.audioName);
      
      // 从多语言内容提取协议文本并生成索引
      const matches = content.match(/\[([^\]]+)\]/g) || [];
      this.extractedProtocols = matches.map(match => match.slice(1, -1)); // 去除方括号
      
      // 替换为带数字索引的链接
      return content.replace(/\[([^\]]+)\]/g, 
        (match, text) => {
          const index = this.extractedProtocols.indexOf(text);
          return `[<a href="#" class="protocol-link" style="color: #377CFB;" data-index="${index}">${text}</a>]`;
        }
      );
    },
    progressShow(){
      const status = [0,2,3,21]
      return status.includes(this.account_status) && this.openServerData?.process_id != 4;
    },
    audioName() {
      const audioMap = {
        '6': 'zq',
        '3': 'qh',
        '6,3': 'zq+qh',
        '3,6': 'zq+qh'
      };
      return audioMap[this.serverIdData?.server_id] || 'zq';
    },
    audioDurationText(){
      const duration = (this.audioDuration / this.playbackRate) || 0;
      if(!duration) return '0' + this.$t('open_account.risk_disclosure.p9');
      const minutes = Math.floor(duration / 60);
      const seconds = Math.floor(duration % 60);
      return minutes > 0 ? `${minutes} ${this.$t('open_account.risk_disclosure.p8')} ${seconds} ${this.$t('open_account.risk_disclosure.p9')}` : `${seconds} ${this.$t('open_account.risk_disclosure.p9')}`;
    },
    audioSources(){
      const languageMap = {
        cn: 'cn',
        hk: 'hk',
        en: 'en'
      };
      const sources = {};
      Object.keys(languageMap).forEach(lang => {
        const suffix = languageMap[lang];
        sources[lang] = require(`@/assets/images/open-account/fxpl/${this.audioName}-${suffix}.mp3`);
      });
      return sources;
    },
    progressPercent() {
      if (!this.audioDuration) return 0;
      return (this.currentTime / this.audioDuration) * 100;
    },
    languageOptions() {
      const localLang = localStorage.getItem('localLang') || 'zh-CN';
      const allOptions = [
        { name: this.$t('open_account.risk_disclosure.p4'), value: 'cn' },
        { name: this.$t('open_account.risk_disclosure.p5'), value: 'hk' },
        { name: this.$t('open_account.risk_disclosure.p6'), value: 'en' }
      ];
      
      let filteredOptions = allOptions;
      if (localLang === 'en') {
        filteredOptions = allOptions.filter(item => item.value === 'en');
      } else {
        filteredOptions = allOptions.filter(item => item.value !== 'en');
      }
      
      return filteredOptions.map(item => ({
        ...item,
        color: item.value === this.currentLanguage ? '#377CFB' : ''
      }));
    },
    speedOptions() {
      return [
        { name: '1.0' + this.$t('open_account.risk_disclosure.p3'), value: 1.0 },
        { name: '1.5' + this.$t('open_account.risk_disclosure.p3'), value: 1.5 },
        { name: '2.0' + this.$t('open_account.risk_disclosure.p3'), value: 2.0 },
        { name: '3.0' + this.$t('open_account.risk_disclosure.p3'), value: 3.0 },
        { name: '4.0' + this.$t('open_account.risk_disclosure.p3'), value: 4.0 }
      ].map(item => ({
        ...item,
        color: item.value === this.playbackRate ? '#377CFB' : ''
      }));
    },
    languageText() {
      const item = this.languageOptions.find(item => item.value === this.currentLanguage);
      return item ? item.name : this.$t('open_account.risk_disclosure.p4');
    },
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    arrowIcon() {
      return this.bgColor === 'black-theme' 
        ? require('../../../assets/images/white-down.png') 
        : require('../../../assets/images/arrow-down.png');
    },
    currentLang() {
      return this.$i18n.locale || 'zh';
    }
  },
  created() {
  },
  methods: {
    init() {
      const localLang = localStorage.getItem('localLang') || 'zh-CN';
      const langMap = {
        'zh-CN': 'cn',
        'zh-HK': 'hk',
        'en': 'en'
      };
      this.currentLanguage = langMap[localLang] || 'cn';
      this.handDetail();
      this.initScroll();
    },
    togglePlay() {
      if (this.playing) {
        this.pause();
      } else {
        this.play();
      }
    },
    play(){
      this.playing = true;
      this.showGesture = false;
      if (this.$refs.audioPlayer) {
        this.$refs.audioPlayer.play();
      }
    },
    pause(){
      this.playing = false;
      if (this.$refs.audioPlayer) {
        this.$refs.audioPlayer.pause();
      }
    },
    onAudioEnded(){
      this.playing = false;
      this.audioCompleted = true;
    },
    onAudioLoaded(){
      if(this.$refs.audioPlayer){
        this.audioDuration = this.$refs.audioPlayer.duration;
        this.$refs.audioPlayer.playbackRate = this.playbackRate;
      }
    },
    onTimeUpdate() {
      if (this.$refs.audioPlayer) {
        this.currentTime = this.$refs.audioPlayer.currentTime;
      }
    },
    toggleLanguageSelect() {
      this.showType = this.showType === 1 ? 0 : 1;
    },
    toggleSpeedSelect() {
      this.showType = this.showType === 2 ? 0 : 2;
    },
    selectLanguage(item) {
      this.showType = 0;
      const value = item.value;
      if (value === this.currentLanguage) return;
      
      const wasPlaying = this.playing;
      this.currentLanguage = value;
      this.audioDuration = 0;
      this.currentTime = 0;
      
      if(this.$refs.audioPlayer){
        this.$refs.audioPlayer.pause();
        this.$refs.audioPlayer.currentTime = 0;
        this.$refs.audioPlayer.load();
        this.playing = false;
        if (wasPlaying) {
          this.$nextTick(() => {
            this.play();
          });
        }
      }
    },
    selectSpeed(item) {
      this.playbackRate = item.value;
      if(this.$refs.audioPlayer){
        this.$refs.audioPlayer.playbackRate = this.playbackRate;
      }
      this.showType = 0;
    },

    getInfo(){
      const key = this.serverIdData?.server_id == '6' ? 'licensed_securities_representative' : 'licensed_futures_representative'
      this.$apis.getEnum({
        key
      }).then((res) => {
        if(res && res.length > 0){
          this.userInfoData = JSON.parse(res?.[0]?.value_display);
        }
      })
    },
    handDetail() {
      const params = {
        step_code:''
      }
      this.$apis.accountSituationV2(params).then(res => {
        if (!res) return;
        const data = res;
        this.account_status = data.account_status
        const status = [0,2,3,21]
        
        if(status.includes(this.account_status)){
          const { process_id } = data.process_info?.['1'] || {}
          this.process_id = process_id
        }
        this.openServerData = data.process_info?.open_server
        if(data.process_info?.open_server?.config_data){
          this.serverIdData = JSON.parse(data.process_info.open_server.config_data)
        }else{
          this.serverIdData = JSON.parse(data.process_info?.['12']?.config_data || '{}')
        }
        
        // 判断是否已听完音频标记
        const isAddAccount = this.openServerData?.process_id == 4
        const stepKey = isAddAccount ? '4' : '13'
        const stepData = data.process_info?.[stepKey]
        if(stepData?.config_data){
          const configData = JSON.parse(stepData.config_data)
          if(configData?.audio_listened){
            this.audioCompleted = true
          }
        }
        
        // serverIdData 获取到后重新加载音频
        this.$nextTick(() => {
          if(this.$refs.audioPlayer){
            this.$refs.audioPlayer.load();
          }
        });
        
        this.getInfo();
      });
    },
    handleNext() {
      if(!this.audioCompleted){
        Toast(this.$t('open_account.risk_disclosure.p10'));
        return;
      }
      const status = [0,2,3,21]
      let params = {
        process_id: !status.includes(this.account_status) ? 4 : this.process_id,
        step_code: !status.includes(this.account_status)  ? 'futures_risk' : 13,
        step_order: !status.includes(this.account_status)  ? 4 : 13,
        config_data: {
          audio_listened: true
        }
      };
      if(this.openServerData?.process_id == 4){
        params = {
          process_id: 4,
          step_code: 'futures_risk',
          step_order: 4,
          config_data: {
            audio_listened: true
          }
        }
      }
      const toastLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      this.$apis.supplementSaveApi(params).then(res => {
        if (res) {
          this.$router.push({
            path: "/open-account/agreementDeclaration"
          }).finally(() => {
            toastLoading.clear();
          });
        }
      });
    },
    initScroll(){
      this.isRead = false;
      this.$nextTick(() => {
        const box = document.getElementById("app");
        if(box.scrollTo){
          box.scrollTo(0,0)
        }else{
          box.scrollTop = 0
        }
        box.onscroll = null;
        let first = true;
        box.onscroll = _.throttle(() => {
          if((first && box.scrollTop > 0) || (this.$route.path !== location.pathname)){
            if(box.scrollTo){
              box.scrollTo(0,0)
            }else{
              box.scrollTop = 0
            }
            first = false
          }
          const clientHeight = box.clientHeight;
          const scrollTop = box.scrollTop;
          const scrollHeight = box.scrollHeight;
          if (scrollTop + clientHeight + 10 >= scrollHeight) {
            this.isRead = true;
          }
        }, 100);
      });
    },
    handleLinkClick(e) {
      if (e.target.classList.contains('protocol-link')) {
        e.preventDefault();
        const index = parseInt(e.target.dataset.index);
        const protocolTypeMap = {
          0: 1,
          1: 11
        };
        openAgreementPdf(protocolTypeMap[index]);
      }
    },
  },
  beforeRouteLeave(to, from, next){
    if (this.$refs.audioPlayer) {
      this.$refs.audioPlayer.pause();
      this.$refs.audioPlayer.currentTime = 0;
    }
    next();
  },
  destroyed() {

  }
};
</script>

<style lang="less" scoped>
.page-header {
  margin-top: 62px;
  color: #17161c;
  font-size: 36px;
  font-weight: 500;
  line-height: 88px;
  padding: 14px 32px 0;
  height: auto;
  border-bottom: #f3f3f3 solid 1px;
  &.en-header{
    line-height: 1.4;
    padding: 20px 32px;
  }
}
.page-content {
  padding-top: 20px;
}
.audio-wrapper{
  padding: 20px 32px 0;
  position: relative;
}
.audio-container{
  background: linear-gradient(0deg,#f8fbff 0%, #ebf4ff 100%);
  border-radius: 16px;
  padding: 24px;
}
.info-box{
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  .head-img{
    width: 140px;
    height: 140px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    .img{
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .text-box{
    flex: 1;
    margin: 0 24px;
    .name{
      font-weight: 500;
      font-size: 28px;
      color: #17161C;
      margin-bottom: 12px;
    }
    .code{
      font-size: 26px;
      color: #17161C;
    }
  }
  .btn-wrapper{
    position: relative;
    flex-shrink: 0;
  }
  .btn{
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: #377CFB;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 12px rgba(55, 124, 251, 0.4);
    &:active{
      transform: scale(0.95);
    }
  }
  .play-icon{
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 16px 0 16px 28px;
    border-color: transparent transparent transparent #fff;
    margin-left: 6px;
  }
  .pause-icon{
    width: 28px;
    height: 32px;
    display: flex;
    justify-content: space-between;
    &::before,
    &::after{
      content: '';
      width: 8px;
      height: 100%;
      background: #fff;
      border-radius: 2px;
    }
  }
  .gesture-icon{
    position: absolute;
    top: 68px;
    left: 50%;
    margin-left: -20px;
    font-size: 40px;
    animation: gesture-bounce 1s infinite;
    pointer-events: none;
    line-height: 1;
  }
}
.audio-controls{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 12px;
  gap: 20px;
  .control-item{
    display: flex;
    align-items: center;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    backdrop-filter: blur(10px);
    &:active{
      background: rgba(255, 255, 255, 0.3);
    }
  }
  .control-label{
    font-size: 26px;
    color: #17161C;
    margin-right: 4px;
  }
  .icon {
    width: 32px;
    height: 32px;
    transform: translateY(-3px);
  }
  .control-icon{
    font-size: 22px;
    color: #17161C;
  }
  .duration-text{
    font-size: 26px;
    color: #17161C;
    margin-left: auto;
    white-space: nowrap;
  }
}
.progress-bar{
  width: 100%;
  height: 4px;
  background: #E6EDFB;
  border-radius: 24px;
  overflow: visible;
  position: relative;
  .progress-fill{
    height: 100%;
    background: #A4CAFF;
    transition: width 0.3s;
    position: relative;
    border-radius: 24px;
  }
  .progress-dot{
    position: absolute;
    right: -6px;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
  }
}

@keyframes gesture-bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.detail-wrap {
  padding: 0 32px 200px 32px;
  h2,
  h3 {
    padding: 20px 0;
  }

  p {
    padding: 10px 0;
    line-height: 45px;
    font-size: 28px;
    color: #17161C;

    &:last-child {
      padding-bottom: 60px;
    }
  }
}

.footer-panel {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 274px;
  width: 100%;
  padding: 40px 50px 20px;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0px -5px 10px 0px rgba(136, 136, 136, 0.3);

  .sub-btn {
    padding-top: 53px;
    color: #001870;
    text-align: center;
  }
}

@black: #1B1C24;
.black-theme {
  background-color: @black;
  min-height: 100%;
  color: #fff;
  .audio-container{
    background: linear-gradient(135deg, #2d3561 0%, #3d2b52 100%);
  }
  .info-box{
    .name{
      color: #fff;
    }
    .code{
      color: rgba(255, 255, 255, 0.7);
    }
  }
  .audio-controls{
    .control-item{
      background: rgba(255, 255, 255, 0.15);
      &:active{
        background: rgba(255, 255, 255, 0.25);
      }
    }
    .control-label{
      color: #fff;
    }
    .control-icon{
      color: #fff;
    }
    .duration-text{
      color: rgba(255, 255, 255, 0.7);
    }
  }
  .progress-bar{
    background: rgba(255, 255, 255, 0.2);
    .progress-fill{
      background: #fff;
    }
  }
  .detail-wrap {
    p {
      color: #FFFFFF;
    }
  }
  .page-header {
    color: #fff;
    border-color: #323442;
  }
  .page-content {
    background-color: @black;
    color: #fff;
    padding-top: 20px;
  }
  .footer-panel {
    background-color: @black;
    color: #fff;
    .sub-btn {
      color: #377CFB;
    }
  }
}
.none-page{
  margin-top: 0px;
}
</style>
